"use client";

import { useEffect } from "react";
import { captureAttribution } from "@aluume/shared/lib/tracking/client";

/**
 * Captures UTM + click-ids from the entry URL (and the ad-platform cookies) on
 * mount and persists them for the funnel. See lib/tracking/client.captureAttribution.
 * Mounted once at the root via <AttributionCapture/>.
 */
export function useAttributionCapture() {
  useEffect(() => {
    // /n/<token> is the neighbour link: never persist a token URL as a landing page.
    if (window.location.pathname.startsWith("/n/")) return;
    captureAttribution();
  }, []);
}
